@if (action == undefined) {
  <div class="card">
    <div class="row pad5">
      @for (tbl of dataResource.table; track tbl; let i = $index) {
        <div class='{{tbl.class}}'>
          @if (tbl.icon == 'fa fa-plus' && freshMedicineArr != undefined) {
            <h4>
              <div class="text-center">{{tbl.label}}</div>
            </h4>
          }
          @if (tbl.icon == 'fa fa-trash' && secondArr != undefined) {
            <h4>
              <div class="text-center">{{tbl.label}}</div>
            </h4>
          }
          @if (tbl.filter && i===0) {
            <div class="d-flex align-items-center">
              <div class="">
                @if (tbl.filter != undefined) {
                  <div>
                    <button type="button" class="secondary-btn" (click)="displayFilter(i)">
                      <span>{{'Filter' | translate | async}}</span>
                      <i class="fa fa-filter" aria-hidden="true"></i>
                    </button>
                  </div>
                }
              </div>
            </div>
          }
          @if (tbl.filter && i===1) {
            <div class="d-flex align-items-center">
              <div class="">
                @if (tbl.filter != undefined) {
                  <div>
                    <button type="button" class="secondary-btn" (click)="displayFilter_1(i)">
                      <span>{{'Filter' | translate | async}}</span>
                      <i class="fa fa-filter" aria-hidden="true"></i>
                    </button>
                  </div>
                }
              </div>
            </div>
          }
          @if (config.filter_0 && i===0) {
            <div class="card">
              <div class="row filter-grid">
                <ng-container>
                  <div class="col-12 pl-4 pr-4">
                    <div class="grid_filter">
                      <div class="filter-body">
                        <!-- <span class="filter-arrow"><i class="fa fa-caret-up" aria-hidden="true"></i></span> -->
                        <span class="close-filter-btn" (click)="displayFilter(i)">
                          <i class="fa fa-times-circle" aria-hidden="true"></i></span>
                          @if (tbl.filter) {
                            <div class="filter-form">
                              <kx-filter [config]="{}" [fields]="tbl.filter" (getFilter)="doSearch($event,i)"
                                (resetFilter)=resetFilter($event,i)>
                              </kx-filter>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            }
            @if (tbl.config) {
              <div class="_complex-search mb-2">
                <app-complex-search class="d-flex" [config]="tbl.config" (onFilterChange)="filterClick($event,i);">
                </app-complex-search>
              </div>
            }
            @if (tbl.search) {
              <div class="_complex-search mb-2">
                <app-complex-search class="d-flex" [config]="{}" (onFilterChange)="filterClick($event,i);">
                </app-complex-search>
              </div>
            }
            @if (config.filter_1 && i===1) {
              <div class="card">
                <div class="row filter-grid">
                  <ng-container>
                    <div class="col-12 pl-4 pr-4">
                      <div class="grid_filter">
                        <div class="filter-body">
                          <!-- <span class="filter-arrow"><i class="fa fa-caret-up" aria-hidden="true"></i></span> -->
                          <span class="close-filter-btn" (click)="displayFilter_1()">
                            <i class="fa fa-times-circle" aria-hidden="true"></i></span>
                            @if (tbl.filter) {
                              <div class="filter-form">
                                <kx-filter [config]="{}" [fields]="tbl.filter" (getFilter)="doSearch($event,i)"
                                  (resetFilter)=resetFilter($event,i)>
                                </kx-filter>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              }
              <div class="table-container">
                <div class="table-responsive">
                  <table class="base-table">
                    <thead>
                      <tr>
                        @if (checkactionAondition(tbl)) {
                          <th scope="col">Action</th>
                        }
                        <!-- <th scope="col" *ngIf="!(dataResource.table[0].hasOwnProperty('hideAction') && dataResource.table[0].hasOwnProperty('hideAction'))">Action</th> sanjeev -->
                        @for (clm of tbl.column.split(','); track clm; let j = $index) {
                          <th scope="col">{{clm}}</th>
                        }
                      </tr>
                    </thead>
                    @if (tbl.icon == 'fa fa-plus' && freshMedicineArr != undefined) {
                      <tbody>
                        @if (tbl.icon == 'fa fa-plus' && freshMedicineArr.length <=0) {
                          <tr>
                            <td [attr.colspan]="tbl.key.split(',').length+2" class="makeCenter">
                              <span>No data found.</span>
                            </td>
                          </tr>
                        }
                        @for (md of freshMedicineArr; track md; let k = $index) {
                          <tr class="height0">
                            @if (checkactionAondition(tbl)) {
                              <td>
                                <span class="ca-actions pr-2" (click)="setItem(tbl,md)">
                                  <span class="fa fa-plus-circle"></span>
                                </span>
                              </td>
                            }
                            @for (ky of tbl.key.split(','); track ky; let mk = $index) {
                              <td>
                                @if (ky == 'expiry_date' || ky =='order_date_time') {
                                  {{md[ky] |
                                  dateFormat}}
                                }
                                @if (ky != 'expiry_date' && ky !='order_date_time') {
                                  {{md[ky]}}
                                }
                              </td>
                            }
                          </tr>
                        }
                      </tbody>
                    }
                    @if (tbl.icon == 'fa fa-trash' && secondArr != undefined) {
                      <tbody>
                        @for (md of secondArr; track md; let k = $index) {
                          <tr class="height0">
                            @if (checkactionAondition(tbl)) {
                              <td>
                                <span class="ca-actions pr-2" (click)="deleteItem(md,md.id,tbl)">
                                  <span class="fa fa-trash"></span>
                                </span>
                              </td>
                            }
                            @for (ky of tbl.key.split(','); track ky; let mk = $index) {
                              <td>
                                @if ( getfieldType(ky) && ky == 'expiry_date' || ky =='order_date_time') {
                                  {{md[ky] | dateFormat}}
                                }
                                @if (getfieldType(ky) && !isUniqueBarCodeField(ky) && ky != 'expiry_date' && ky !='order_date_time') {
                                  {{md[ky]}}
                                }
                                @if (!getfieldType(ky) && ky != 'expiry_date' && ky !='order_date_time') {
                                  <input type="number" id="{{md[ky]}}" [(ngModel)]="md[ky]"
                                    class="form-control" />
                                }
                                @if (isUniqueBarCodeField(ky)) {
                                  <input type="checkbox" [(ngModel)]="md[ky]"/>
                                }
                              </td>
                            }
                            <!-- <td *ngFor="let ky of tbl.key.split(','); let mk=index;">
                            <ng-container *ngIf="getfieldType(ky);">
                              {{md[ky]}}
                            </ng-container>
                            <ng-container *ngIf="!getfieldType(ky);">
                              <input type="number" id="{{md[ky]}}" [(ngModel)]="md[ky]" class="form-control" />
                            </ng-container>
                          </td> -->
                        </tr>
                      }
                      @if (tbl.icon == 'fa fa-trash' && secondArr.length <=0) {
                        <tr>
                          <td [attr.colspan]="tbl.key.split(',').length+2" class="makeCenter">
                            <span>No data found.</span>
                          </td>
                        </tr>
                      }
                      <!-- <div style="height: auto; background-color: #F2F2F2;"></div> -->
                    </tbody>
                  }
                </table>
              </div>
            </div>
            <!-- <div class='col-lg-12' *ngIf="freshMedicineArr == [] && secondArr == []">
            <span>No data found.</span>
          </div> -->
          <!-- *ngIf="pagination" -->
          <div class='col-lg-12'>
            @if (itemsCount1 && tbl.icon == 'fa fa-plus') {
              <dhs-pagination [itemsCount]="itemsCount1"
                [limit]="limit1" [startPage]="page_no" (pageChange)="onPageChanged1($event,tbl.filter,i)"
                (onLimitChanges)="limitChange1($event)">
              </dhs-pagination>
            }
            @if (itemsCount2 && tbl.icon == 'fa fa-trash') {
              <dhs-pagination [itemsCount]="itemsCount2"
                [limit]="limit2" [startPage]="page_no" (pageChange)="onPageChanged2($event,tbl.filter,i)"
                (onLimitChanges)="limitChange2($event)">
              </dhs-pagination>
            }
          </div>
        </div>
      }
    </div>
  </div>
}
@if (action!=undefined && action=='VIEW' && fieldGroup && secondArr.resource!=undefined && secondArr.resource.length!=undefined && secondArr.resource.length>0) {
  <div
    >
    <dhs-data-grid [fields]="fieldGroup" [data]="secondArr" [config]="configList">
    </dhs-data-grid>
  </div>
}